import axios, { AxiosError } from 'axios';
import { Apiestoque } from '../../axiosestoque';

interface IFoto {
  imgPath: string
}

interface ItensOs {
  qtdsaida: number;
  descricao: string;
  un: string;
  preco: number;
  total: number;
} 

export interface IROs {
  idos: string;
  numero: number;
  numeropat: string;
  dataabertura: Date;
  datafechamento: Date;
  operador: string;
  mecanico: string;
  defeitoconstatado: string;
  defeitoreclamado: string;
  servicosrealizados: string;
  fazenda: string;
  situacao: string;
  descricao: string;
  ano: number;
  modelo: string;
  status: boolean;
  fabricante: string;
  fotos: IFoto;
  itens: ItensOs[];
}

export interface ILocalizacao {
  idprod: string;
  descricao: string;
  referencia: string;
  qtdestoque: number;
}

export interface IVencimentos {
  idprod: string;
  descricao: string;
  referencia: string;
  validade: Date;
  dias: number;
  qtdestoque: number;
}

export interface IOperacao{
  idoperacoes: string;
  idfazenda: string;
  idcultivo: string;
  idparceiro: string;
  datainicial: Date;
  datafinal: Date;
  detalhes: boolean;
  vendas: boolean,
  tipo: number,
}

interface Item {
  iditens: string;
  descricao: string;
  validade: Date;
  referencia: string;
  localizacao: string;
  qtdsaida: number;
  preco: number;  
  total: number;
}

interface ItemEnt {
  iditens: string;
  descricao: string;
  un: string;
  conversor: number;
  validade: Date;
  referencia: string;
  localizacao: string;
  qtdentrada: number;
  preco: number;  
  total: number;
}

interface Saida {
  idsaida: string;
  dataoperacao: string;
  cultivo: string;
  fazenda: string;
  parceiro: string;
  total: number;
}

interface entrada {
  identrada: string;
	dataemissao: string;
	numerodoc: string;
	numeronota: string;
	nome: string;
	cpf: string;
	subtotal: number;
	desconto: number;
	acrescimo: number;
	totalnota: number;
	planoconta: string;
	operacao: string;
}

interface Entry {
  saida: Saida;
  itens: Item[];
}

export interface IAbastecimento {
  dataoperacao: Date;
  numero: string;
  horimetronicial: number;
  horimetro: number;
  horastrabalhadas: number;
  quantidade: number;
  litros: number;
  operador: string;
  cultivo: string;
  pivot: string;
  fazenda: string;
  atividade: string;
}


interface EntryEntrada{
  entrada: entrada;
  itens: ItemEnt[];
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const Localizacao = async (localizacao = '', tipo = '', grupo = '', subgrupo = ''): Promise<ILocalizacao[] | Error> => {
  try {
    const urlRelativa = `/rlocalizacao?tipo=${tipo}&localizacao=${localizacao}&grupo=${grupo}&subgrupo=${subgrupo}`;
  
    const { data } = await Apiestoque.get(urlRelativa);
  
    if (data) {
      return data;
    }
  
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Vencimentos = async (localizacao = '', tipo = '', dias = ''): Promise<IVencimentos[] | Error> => {
  try {
    const urlRelativa = `/restoquevencimentos?tipo=${tipo}&localizacao=${localizacao}&dias=${dias}`;
  
    const { data } = await Apiestoque.get(urlRelativa);
  
    if (data) {
      return data;
    }
  
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const relatorioAbastecimento = async (fazenda = '', cultivo = '', patrimonio = '', tipo = '', datainicial: string, datafinal: string): Promise<IAbastecimento[] | Error> => {
  try {
    const urlRelativa = `/rabastecimento?idfazenda=${fazenda}&idcultivo=${cultivo}&idpatrimonio=${patrimonio}&tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Apiestoque.get(urlRelativa);
    if (data) {   
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Operacoes = async (dados: IOperacao): Promise<Entry[] | Error> => {
  try {

    const { data } = await Apiestoque.post<Entry[]>('/restoqueoperacoes', dados);
   
    if (data) {
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const OperacoesEntrada = async (dados: IOperacao): Promise<EntryEntrada[] | Error> => {
  try {

    const { data } = await Apiestoque.post<EntryEntrada[]>('/restoqueoperacoes', dados);
   
    if (data) {
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Os = async (filter = '', tipo = '', datainicial: string, datafinal: string): Promise<IROs[] | Error> => {
  try {
    const urlRelativa = `/relatorioos?filter=${filter}&tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Apiestoque.get(urlRelativa);
    if (data) {   
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
 
export const RelatorioEstoqueService = {
  Localizacao,
  Vencimentos,
  Operacoes,
  OperacoesEntrada,
  relatorioAbastecimento,
  Os,
}; 